module.exports = __webpack_public_path__ + "static/media/som.76c5ba16.jpg";